import request from '@/utils/request'
import api from '../api'

export class Merchant {
  add(data) {
    return request({
      url: api.merchant.add,
      method: 'post',
      data
    })
  }
  retrieve(params) {
    return request({
      url: api.merchant.retrieve,
      method: 'get',
      params
    })
  }
  queryById(params) {
    return request({
      url: api.merchant.queryById,
      method: 'get',
      params
    })
  }
  findMerchantBaseInfo(params) {
    return request({
      url: api.merchant.findMerchantBaseInfo,
      method: 'get',
      params
    })
  }
  findByMerchantNumber(params) {
    return request({
      url: api.merchant.findByMerchantNumber,
      method: 'get',
      params
    })
  }
  downLoadAgreement(params) {
    return request({
      url: api.merchant.downLoadAgreement,
      method: 'get',
      params
    })
  }
  uploadAgreement(data) {
    return request({
      url: api.merchant.uploadAgreement,
      method: 'post',
      data
    })
  }
  updateMerchantIntegrateStep(params) {
    return request({
      url: api.merchant.updateMerchantIntegrateStep,
      method: 'get',
      params
    })
  }
  findProductById(params) {
    return request({
      url: api.merchant.findProductById,
      method: 'get',
      params
    })
  }
  getfindByCustomerManagerCode(params) {
    return request({
      url: api.merchant.getfindByCustomerManagerCode,
      method: 'get',
      params
    })
  }
  newQueryCity(data) {
    return request({
      url: api.merchant.newQueryCity,
      method: 'post',
      data
    })
  }
  reconciliationList(data) {
    return request({
      url: api.merchant.reconciliationList,
      method: 'post',
      data
    })
  }
  exportReconciliation(data) {
    return request({
      url: api.merchant.exportReconciliation,
      method: 'post',
      data
    })
  }
}